/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { element } from '../../core/elements';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _3 = "._syaz1t5i{color:var(--ds-icon-subtle)}";
const _2 = "._4t3i1tcg{height:24px}";
const _ = "._1bsb7vkz{width:1pc}";
const iconStyle = null;
function Icon(_ref) {
  let {
    children
  } = _ref;
  if (!children) return null;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1bsb7vkz _4t3i1tcg _syaz1t5i"]),
      children: children
    })]
  });
}
const _Icon = element(Icon);
export { _Icon as Icon };